// SCSS & CSS
import './css/global.css';
import './styles/library.scss';
import './styles/antd.scss';
import './styles/mobiscroll.scss';
import './styles/extrastrap.scss';
import './css/renew.css';
import './css/products.css';
// Library Style
import '@mobiscroll/react/dist/css/mobiscroll.react.scss';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'react-image-lightbox/style.css';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
// Components Style
import '@Components/V2/AppRouter.scss';
import '@Components/acl/Thailand/style.css';
import '@Components/genealogy/genealogy-filter.scss'

import '@Stores/GlobalWatchers';